export default __webpack_public_path__ + "static/media/coleta-mujer-azul.63738ec2.png";